import { GlassLink } from '@components/glass/GlassButton';
import { GlassSurface } from '@components/glass/GlassSurface';
import { ThemeToggle } from '@components/ThemeToggle';
import { Logo } from '@components/ui/Logo';
import { PRIMARY_CTA } from '@config/site';

import { MenuButton } from './MenuButton';
import { MobileMenu } from './MobileMenu';
import { NavLinks } from './NavLinks';
import styles from './SiteHeader.module.scss';

/**
 * The floating header: one bar of `floating` glass. Page content scrolling
 * beneath it softens into blurred colour and bends at the rim, while the
 * light tint keeps the bar itself airy rather than a dark strip.
 */
export const SiteHeader = () => (
  <header className={styles.header}>
    <GlassSurface variant="floating" className={styles.bar}>
      <Logo />

      <nav aria-label="Primary" className={styles.desktopNav}>
        <NavLinks />
      </nav>

      <div className={styles.actions}>
        <ThemeToggle />
        <GlassLink to={PRIMARY_CTA.to} tone="primary" className={styles.cta}>
          {PRIMARY_CTA.label}
        </GlassLink>
        <MenuButton className={styles.menuButton} />
      </div>
    </GlassSurface>

    <MobileMenu />
  </header>
);
